import styled from 'styled-components'

import { Colors } from '@utils/Colors'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 24px;
`

export const VideoWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
`

export const StyledVideo = styled.video`
  width: 100%;
  height: auto;
  display: block;
`

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${Colors.PRIMARY500};
  color: white;
  font-size: 24px;
  padding: 16px;
  border: none;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: darkorange;
  }
`

export const InstructionList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const InstructionItem = styled.li`
  display: flex;
  font-family: Inter, inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${Colors.GRAY500};
  align-items: center;

  .number {
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    background-color: ${Colors.GRAY500};
    min-width: 24px;
    max-width: 24px;
    min-height: 24px;
    max-height: 24px;
    color: ${Colors.WHITE};
    text-align: center;
    align-self: center;
    justify-content: center;
    font-family: Inter, inter;
    font-weight: 700;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
    border-radius: 50%;
    margin-right: 16px;
  }
`

export const ShowMoreText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 12px;
  gap: 8px;
  font-family: Inter, inter;
  font-weight: 700;
  font-size: 14px;
  color: ${Colors.PRIMARY500};
  cursor: pointer;
`

export const ArrowUp = styled.span`
  font-size: 24px;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
`

export const ArrowDown = styled.span`
  font-size: 24px;
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
`
